module.exports = __webpack_public_path__ + "img/cetizhong.0bde9030.png";